import { IEventsInstance } from '../AmplitudeEventsInstance/IEventsInstance';
import { getUserProperties } from '../AmplitudeEventsInstance/getUserProperties.js';
import { cookies } from '../cookies.js';

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        ym: any;
        yaParams: any;
    }
}

/**
 * Класс реализации Measurement Protocol инстанса для отделения логики отправки событий от реализации
 */
export class MeasurementProtocolInstance implements IEventsInstance {
    public sessionId: number | undefined;
    public deviceId: string | undefined;
    public canSendEvent: boolean;

    private readonly COUNTER_ID: number = Number(process.env.YM_COUNTER_ID) || 17186719;
    private readonly MP_TOKEN: string = process.env.YM_MP_TOKEN || '';

    private ym: any;

    constructor() {
        this.sessionId = Date.now();
        this.deviceId = this.getCid();
        this.canSendEvent = true;
        this.ym = window.ym;

        this.run();
    }

    /**
     * Команда выполняемая один раз при инициализации класса
     * Выставляем константы Measurement Protocol
     * Сохраняем идентификаторы в куках и localStorage
     */
    public async run() {
        const userProperties = getUserProperties();

        try {
            if (!this.ym) {
                console.warn('Yandex Metrika not loaded');
                return;
            }

            window.yaParams = {
                ...window.yaParams,
                ...userProperties,
            };

            this.ym(this.COUNTER_ID, 'params', window.yaParams || {});
        } catch (error) {
            throw new Error('Error initializing MeasurementProtocolInstance', { cause: error });
        }

    }

    private getCid() {
        return cookies.getCookie('_ym_uid') || '123';
    }

    /**
     * Конкретная реализация отправки событий
     *
     * @param eventGroup
     * @param eventName
     * @param eventValue
     */
    public sendEvent = async (
        _: string,
        eventName: string,
        eventValue: any
    ) => {
        if (!this.canSendEvent) return;

        const params = new URLSearchParams({
            tid: this.COUNTER_ID.toString(),
            cid: this.getCid(),
            t: 'event',
            ea: eventName,
            params: JSON.stringify(eventValue),
            ms: this.MP_TOKEN,
        });

        const url = `https://mc.yandex.ru/collect?${params.toString()}`;

        fetch(url, {
            method: 'GET',
            mode: 'no-cors',
        }).catch((error) => {
            throw new Error('Error measurementProtocol fetch event ', { cause: error });
        });
    };
}
